export const equipmentClick = (row, fonctionid, fonctionsname) => {
  let p = `"/equipmentGrpEqiupment/"${sessionStorage.getItem("eqBez")}/${
    fonctionid === undefined && fonctionid + "/" + fonctionsname
  }/${parseInt(row.id)}/${row.bezeichnung}/${row.inventarnr}`;
  const rowbez =
    row.bezeichnung !== null &&
    row.bezeichnung !== undefined &&
    row.bezeichnung.length != 0
      ? row.bezeichnung
      : "-";
  const path =
    "/equipmentGrpEqiupment/" +
    sessionStorage.getItem("eqBez") +
    "/" +
    fonctionid +
    "/" +
    fonctionsname +
    "/" +
    parseInt(row.id) +
    "/" +
    rowbez +
    "/" +
    row.inventarnr;

  return path;
};

export const removeItem = (index, childObject, childInfo) => {
  let valueObj = [];
  if (childObject[index].equipId === childInfo.equipId) {
    childObject.map((item, i) => {
      if (i < index + 1) {
        valueObj.push(item);
      }
    });

    return valueObj;
  } else {
    childObject.map((item, i) => {
      if (i !== index) {
        valueObj.push(item);
      }
    });
    valueObj.push({
      equipId: childInfo.equipId,
      inventarnr: childInfo.inventarnr,
      bezeichnung: childInfo.bezeichnung,
    });
    return valueObj;
  }
};

export const addItem = (childObject, childInfo) => {
  let valueObj = [...childObject];
  valueObj.push({
    equipId: childInfo.equipId,
    inventarnr: childInfo.inventarnr,
    bezeichnung: childInfo.bezeichnung,
  });
  return valueObj;
};
